import { mapTrackingData } from '@/services/utils';
angular.module('leanlaw').controller('MatterFixedCtrl', ['userService', '$scope', 'leanLawApi', '$state', 'chargeManager', 'lists', 'tracking', 'viewInvoiceService', function (userService, $scope, leanLawApi, $state, chargeManager, lists, tracking, viewInvoiceService) {
  $scope.lists = lists;
  $scope.chargeEdit = chargeEdit;
  $scope.chargeStatusUpdate = chargeStatusUpdate;
  $scope.sort = 'label';
  $scope.sort2 = 'date';
  $scope.charges = {};
  $scope.me = {};
  activate();
  $scope.fixedFeeChange = function () {
    $scope.matter.billing.fixed = angular.copy($scope.data.fixed);
  };
  $scope.clearStandard = function () {
    $scope.data.fixed = {
      label: null
    };
    $scope.matter.billing.fixed.label = null;
  };
  $scope.addStandard = function () {
    $state.go('.addStandard');
  };
  $scope.billedSelected = function (charge) {
    if (!charge.invoice && !charge.invoice.id) return;
    leanLawApi.getInvoice({
      id: charge.invoice.id
    }).then(invoice => {
      viewInvoiceService.viewInvoice(invoice, true);
    });
  };

  ///////////////////////////////////

  async function activate() {
    $scope.me = await userService.me();
    chargeManager.listStandard().then(standard => {
      $scope.standards = standard.select;
      $scope.standards.forEach(el => {
        el.display = el.label || el.description;
      });
      $scope.standards.sort((a, b) => a.display.localeCompare(b.display));
    });
    $scope.$watch('matter', matter => {
      if (!matter.billing) return;
      getChargeList(matter);
    });

    // Listen for Vue component save events to refresh table
    $scope.$on('fixedFeeUpdated', () => {
      if ($scope.matter) {
        getChargeList($scope.matter);
      }
    });
  }
  function getChargeList(matter) {
    $scope.chargesLoading = true;
    chargeManager.listForMatter(matter.id, {
      billed: 'any'
    }).then(charges => {
      const updatedCharges = charges.map(c => ({
        ...c,
        recurrence: c.recurrence && {
          ...c.recurrence,
          period: c.recurrence.period.toLowerCase()
        }
      }));
      const isCompletedOrUpcoming = (charge, today) => (charge.completed || new Date(charge.date) >= today) && charge.billedState === 'WIP';
      const isWIP = charge => charge.billedState === 'WIP';
      const isInterim = charge => charge.billedState === 'Interim';
      const isFinal = charge => charge.billedState === 'Final';
      const today = new Date();
      $scope.charges.completedOrUpcoming = updatedCharges.filter(c => isCompletedOrUpcoming(c, today));
      $scope.charges.WIP = updatedCharges.filter(c => isWIP(c) && !isCompletedOrUpcoming(c, today));
      $scope.charges.interim = updatedCharges.filter(isInterim);
      $scope.charges.final = updatedCharges.filter(isFinal);
      $scope.showBilled = !$scope.charges.interim || $scope.charges.interim.length < 10 || $scope.charges.final || $scope.charges.final.length < 5 || $scope.charges.WIP || $scope.charges.WIP.length < 5;
    }).finally(() => {
      $scope.chargesLoading = false;
    });
  }
  function chargeEdit(charge, showAllocation) {
    $state.go('.charge', {
      chargeId: charge.id,
      showAllocation,
      ledes: $scope.matter.client.codes.ledes
    });
  }
  function chargeStatusUpdate(charge, completed) {
    $scope.chargesLoading = true;
    charge.completed = completed;
    leanLawApi.updateCharge({
      id: charge.id,
      body: charge
    }).then(() => {
      getChargeList($scope.matter);
      if (completed) {
        trackCompletedChargeStatus(charge);
      }
    });
  }
  function trackCompletedChargeStatus(charge) {
    const trackingData = mapTrackingData(charge, $scope.me);
    tracking.event('Update', 'Fixed Fee is marked as complete', trackingData);
  }
}]);